export default __webpack_public_path__ + "static/media/Edit_light.33ab5fe3.svg";